import React, { useContext, useMemo } from "react";
import * as H from "react-helmet";
import { PageContext, ModuleContext } from "../../../contexts";
import { applyKey } from "../../../utils";

const HELMET_ELMENTS = {
  title: (title) => <title>{title}</title>,
  robots: (content) => <meta name="robots" content={content} />,
  description: (content) => (
    <meta name="description" content={content} data-react-helmet="true" />
  ),
  keywords: (content) => <meta name="keywords" content={content} />,
  "og:title": (content) => <meta property="og:title" content={content} />,
};

const Helmet = () => {
  const { moduleName, moduleDescription: description } = useContext(
    ModuleContext
  );
  const { helmet, pageTitle } = useContext(PageContext);

  const helmetData = useMemo(() => {
    const title = `${moduleName} | ${pageTitle}`;
    const objData = { title, "og:title": title, description, ...helmet };

    return Object.keys(HELMET_ELMENTS)
      .filter((key) => objData[key])
      .map((key) => HELMET_ELMENTS[key](objData[key]));
  }, [description, helmet, moduleName, pageTitle]);

  return <H.Helmet>{applyKey(helmetData, (el) => el)}</H.Helmet>;
};

Helmet.propTypes = {};

export default Helmet;
